<template>
  <div class="tiny-box shadow rb">
    <div class="bold small-header margin-bottom paragraph-spacing">
      <span style="font-size: 16px; color: red;">{{
        `${reassessment ? "*" : ""}`
      }}</span>
      <span>{{ title }}</span>
    </div>
    <div :style="{ color: contentColor }">
      <div v-if="numberInput" class="percent semibold">
        <growing-number :value="content" /><span v-if="showPercent">%</span>
      </div>
      <div v-if="!showPercent" class="semibold paragraph-spacing">
        {{ concept }}
      </div>
    </div>
  </div>
</template>

<script>
import { chartColorsMixin } from "@/modules/global/mixins/chartColorsMixin.js";
import GrowingNumber from "@/modules/global/components/GrowingNumber.vue";
export default {
  name: "tinyBoxComponent",
  mixins: [chartColorsMixin],
  props: {
    title: {
      type: String,
      required: false,
      default: ""
    },
    reassessment: {
      type: Boolean,
      default: false
    },
    content: {
      type: Number,
      required: false,
      default: 0
    },
    concept: {
      type: String
    },
    showPercent: {
      type: Boolean,
      default: true
    },
    numberInput: {
      type: Boolean,
      default: true
    }
  },
  components: {
    GrowingNumber
  },
  filters: {},
  computed: {
    contentColor() {
      if (
        (this.content === 0 && !this.concept) ||
        this.concept == "Not Started"
      ) {
        return this.red;
      } else if (
        this.content < 100 &&
        this.showPercent &&
        this.concept !== "Completed"
      ) {
        return this.yellow;
      } else if (
        this.concept !== "Completed" &&
        !this.showPercent &&
        this.content === 0
      ) {
        return this.yellow;
      }
      return this.green;
    }
  }
};
</script>
